import React, { useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from 'antd/lib/select';

import type Location from 'entities/location/model';
import { useCountries } from 'entities/location/api';

const LocationSelector = ({
  selectedLocation = '',
  onSelect,
}: {
  onSelect: (value: string) => void;
  selectedLocation: string | undefined;
}): JSX.Element => {
  const countries: Location[] = useCountries();
  useEffect(() => {
    if (countries?.length === 1 && selectedLocation === '') {
      onSelect(countries[0].countryCode);
    }
  }, [countries]);
  return (
    <>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Choose the country origin of the nonprofit</InputLabel>
      </FormControl>
      <Select
        value={selectedLocation}
        style={{ width: 300 }}
        onChange={(value) => onSelect(value)}
        placeholder="Select a country"
        showSearch
      >
        {countries?.map((country) => (
          <Select.Option key={country.countryCode} value={country.countryCode}>
            {country.country}
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

export default LocationSelector;
